import { I18n } from '@calendly/i18n'
import { CheckboxInput } from '@calendly/ui/components/checkbox-input'
import { BodyText } from '@calendly/ui/components/typography'

import { allValue, MATCH_ATTENDEE, MATCH_MEETING, MATCH_TRANSCRIPT } from 'constants/meetings'

import {
  CheckboxContainer,
  CheckboxLeftColumnWrapper,
  CheckboxRightColumnWrapper,
  LabelContainer,
  OptionWrapper,
  StyledLabel
} from './styles'

const getNewValues = (oldValues, value) => {
  if (value === allValue) {
    return []
  }

  return oldValues.includes(value)
    ? oldValues.filter((method) => method !== value)
    : [...oldValues, value]
}

export const QueryMatches = ({ params, onChange }) => {
  const { searchIn } = params

  const onSelect = (value) => {
    onChange({
      ...params,
      searchIn: getNewValues(searchIn, value)
    })
  }

  return (
    <>
      <CheckboxLeftColumnWrapper>
        <LabelContainer>
          <BodyText weight="bold">
            {I18n.t('publisher.meetings.filter_modal.matches.label')}
          </BodyText>
        </LabelContainer>
      </CheckboxLeftColumnWrapper>
      <CheckboxRightColumnWrapper>
        <CheckboxContainer>
          <OptionWrapper>
            <StyledLabel>
              <CheckboxInput
                id="scheduling_method_all"
                checked={searchIn.length === 0}
                onChange={() => onSelect(allValue)}
              />
              {I18n.t('publisher.meetings.filter_modal.matches.all')}
            </StyledLabel>
          </OptionWrapper>
          <OptionWrapper>
            <StyledLabel>
              <CheckboxInput
                id="query_matches_meeting"
                checked={searchIn.includes(MATCH_MEETING)}
                onChange={() => onSelect(MATCH_MEETING)}
              />
              {I18n.t('publisher.meetings.filter_modal.matches.meeting')}
            </StyledLabel>
          </OptionWrapper>
          <OptionWrapper>
            <StyledLabel>
              <CheckboxInput
                id="query_matches_transcript"
                checked={searchIn.includes(MATCH_TRANSCRIPT)}
                onChange={() => onSelect(MATCH_TRANSCRIPT)}
              />
              {I18n.t('publisher.meetings.filter_modal.matches.transcript')}
            </StyledLabel>
          </OptionWrapper>
          <OptionWrapper>
            <StyledLabel>
              <CheckboxInput
                id="query_matches_attendee"
                checked={searchIn.includes(MATCH_ATTENDEE)}
                onChange={() => onSelect(MATCH_ATTENDEE)}
              />
              {I18n.t('publisher.meetings.filter_modal.matches.attendee')}
            </StyledLabel>
          </OptionWrapper>
        </CheckboxContainer>
      </CheckboxRightColumnWrapper>
    </>
  )
}
